module.exports = __webpack_public_path__ + "img/electronic_electric_use_selected.b7247d96.svg";